import { Button } from 'design-component';
import { ComponentProps, useRef } from 'react';
import styled from 'styled-components';
import { IconUpload } from 'assets/icon';
import { useTranslation } from 'react-i18next';
import { apiWrapper } from 'api';
import ga, { EventOpenSample, EventUpload } from 'util/gaConnect';
import { useAppSelector } from 'store/store';
import { userInfoSelector } from 'store/slices/userInfo';

interface UploadButtonProps extends Omit<ComponentProps<'input'>, 'onChange'> {
  onChange: (file: File) => void;
  isFullSchemaSelected?: boolean;
}

export default function UploadButton(props: UploadButtonProps) {
  const { onChange, isFullSchemaSelected, ...rest } = props;
  const ref = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();
  const userInfo = useAppSelector(userInfoSelector);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!userInfo.isLogged) {
      e.preventDefault();
      e.stopPropagation();
      // alert(t('로그인 필요'));
      apiWrapper(`/api/v1/datainsight/playground/userinfo`);
      return;
    }
    ga.event(EventUpload);
    ref.current?.click(); // 파일 선택창 열기
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.currentTarget.files?.[0];
    if (!file) return;
    // if (file.size === 0) return;

    props.onChange?.(file);

    if (ref.current) {
      ref.current.value = '';
    }
  };

  return (
    <UploadButtonBase
      onClick={handleClick}
      variant="contained"
      color="primary"
      disabled={isFullSchemaSelected}
      startIcon={<IconUpload></IconUpload>}>
      <label>{t('upload')}</label>
      {/* <input
        type="file"
        ref={ref}
        hidden
        onChange={(e) => {
          const file = e.currentTarget.files?.[0];
          if (file?.size === 0) return;
          if (!file) return;

          props.onChange?.(file);
        }}
        {...rest}></input> */}
      <input
        type="file"
        accept=".pdf, .hwp, .hwpx, .doc, .docx, .ppt, .pptx, .xls, .xlsx"
        ref={ref}
        hidden
        onChange={handleFileChange}
        {...rest}></input>
    </UploadButtonBase>
  );
}

const UploadButtonBase = styled(Button)`
  min-width: 94px;
  width: fit-content;
  height: 38px;

  // border: none;
  box-shadow: 0.71px 0.71px 2.83px 0px #0000001a;
  box-shadow: 0px 0.71px 2.12px 0px #00000014;
  gap: 2px;
`;
